// useApiRequest.js
import { useState, useCallback } from "react";
import axios from "axios";

const useApiRequest = () => {
  const [validCredentials, setValidCredentials] = useState(true);

  const makeApiRequest = useCallback(
    async (endpoint, method, data) => {
      try {
        const storedUrl = localStorage.getItem("tandoorUrl") || "";
        const storedToken = localStorage.getItem("apiToken") || "";
        const browserCredentials =
          storedUrl && storedToken
            ? { baseUrl: storedUrl, apiToken: storedToken }
            : {};

        return await axios.post("/api/proxy", {
          method,
          endpoint,
          data,
          ...browserCredentials,
        });
      } catch (error) {
        setValidCredentials(false);
        throw error;
      }
    },
    []
  );

  return {
    makeApiRequest,
    validCredentials,
    setValidCredentials,
  };
};

export default useApiRequest;
